module.exports = __webpack_public_path__ + "img/8.f5904e91.jpg";